import React from 'react';
import './FormWarning.css';

/**
 * Reusable form warning component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to display in the warning
 * @param {'warning'|'info'|'danger'|'success'} props.type - Type of warning (default: 'warning')
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 */
export const FormWarning = ({ children, type = 'warning', className = '', style = {} }) => {
  const getWarningClass = () => {
    switch (type) {
      case 'info':
        return 'form-warning info';
      case 'danger':
        return 'form-warning danger';
      case 'success':
        return 'form-warning success';
      default:
        return 'form-warning';
    }
  };

  return (
    <div 
      className={`${getWarningClass()} ${className}`.trim()}
      style={style}
    >
      {children}
    </div>
  );
};
